import styled from 'styled-components';

import { pill } from '../../styles/mixins';

const Container = styled.div`
  width: 100%;
  max-width: 72rem;
  margin: 3.2rem auto 0;
`;

const Box = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-md);
  padding: 0.6rem 0.6rem 0.6rem 2rem;
  box-shadow: var(--shadow-sm);
  transition: border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);

  :focus-within {
    border-color: var(--accent);
    box-shadow: 0 0 0 4px var(--accent-tint);
  }

  > svg {
    color: var(--ink-faint);
    flex: none;
  }

  input {
    flex: 1;
    min-width: 0;
    height: 4.4rem;
    border: none;
    background: transparent;
    padding: 0;
    font-size: 1.6rem;
    color: var(--ink);

    /* O anel de foco quem desenha é o Box inteiro, no :focus-within acima.
       Sem isto o outline global do :focus-visible aparece como uma segunda
       borda desenhada por dentro da primeira. */
    :focus-visible {
      outline: none;
    }
  }

  @media (max-width: 600px) {
    padding-left: 1.4rem;

    input {
      font-size: 1.5rem;
    }
  }
`;

const SearchButton = styled.button`
  flex: none;
  height: 4.4rem;
  padding: 0 2.4rem;
  border: none;
  border-radius: var(--r-btn);
  background-color: var(--accent);
  color: #fff;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  transition: background-color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);

  :hover {
    background-color: var(--accent-deep);
  }

  :active {
    transform: scale(0.97);
  }

  @media (max-width: 600px) {
    padding: 0 1.6rem;
    font-size: 1.2rem;
  }
`;

const Suggestions = styled.div`
  position: absolute;
  top: calc(100% + 0.8rem);
  left: 0;
  right: 0;
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: var(--shadow-lg);
  padding: 0.6rem;
  z-index: 30;
  max-height: 42rem;
  overflow-y: auto;
  text-align: left;
`;

const Suggestion = styled.button`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1rem 1.2rem;
  border: none;
  background: transparent;
  border-radius: var(--r-sm);
  text-align: left;

  :hover {
    background-color: var(--surface-2);
  }
`;

const SuggestionImage = styled.div`
  width: 4.4rem;
  height: 4.4rem;
  border-radius: var(--r-sm);
  overflow: hidden;
  background-color: var(--surface-2);
  flex: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const SuggestionName = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--ink);
  line-height: 1.3;
`;

const SuggestionMeta = styled.p`
  font-size: 1.25rem;
  color: var(--ink-faint);
  margin-top: 0.2rem;
`;

const SuggestionsEmpty = styled.p`
  padding: 1.6rem 1.2rem;
  font-size: 1.35rem;
  color: var(--ink-faint);
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 1.8rem;
`;

const Chip = styled.button`
  ${pill}
  height: auto;
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  color: var(--ink-soft);
  padding: 0.7rem 1.4rem;
  font-size: 1.3rem;
  font-weight: 500;
  transition: background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);

  :hover {
    background-color: var(--accent-tint);
    border-color: var(--accent);
    color: var(--accent-deep);
  }
`;

export {
  Box,
  Chip,
  Chips,
  Container,
  SearchButton,
  Suggestion,
  SuggestionImage,
  SuggestionMeta,
  SuggestionName,
  Suggestions,
  SuggestionsEmpty,
};
